/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneAssignSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ASSIGN-001
 * PURPOSE: One-tap assign from the org roster. Checklist-scope stays disabled with the desktop reason.
 */
import { useState } from 'react'
import { Check } from 'lucide-react'
import { MobileSheet } from '@quotech/ui'
import type { QaAssigneeCandidate } from '../../../../qa/qaTypes'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneAssignSheet({
  open,
  onClose,
  candidates,
  disabledReason,
  onAssign,
}: {
  open: boolean
  onClose: () => void
  candidates: QaAssigneeCandidate[]
  disabledReason?: string
  onAssign: (userId: number, dueDate: string | null, name?: string) => void
}) {
  const [dueDate, setDueDate] = useState('')
  const [pickedId, setPickedId] = useState<number | null>(null)
  return (
    <MobileSheet open={open} onClose={onClose} title="Assign" size="full">
      <div data-qa-phone-control={QA_PHONE_CONTROLS.assign} className="px-4 py-2">
        {disabledReason ? (
          <p className="text-sm text-muted-foreground">{disabledReason}</p>
        ) : (
          <>
            <label className="mb-2 block text-xs text-muted-foreground">
              Complete by
              <input
                type="date"
                value={dueDate}
                onChange={(event) => setDueDate(event.target.value)}
                className="mt-1 min-h-[44px] w-full rounded-lg border border-border bg-background px-3 text-base"
              />
            </label>
            {candidates.map((person) => (
              <button
                key={person.user_id}
                type="button"
                aria-pressed={pickedId === person.user_id}
                onClick={() => {
                  if (!person.user_id) return
                  setPickedId(person.user_id)
                }}
                className={pickedId === person.user_id
                  ? 'flex min-h-[44px] w-full min-w-0 items-center gap-2 bg-accent text-left'
                  : 'flex min-h-[44px] w-full min-w-0 items-center gap-2 text-left'}
              >
                <span className="truncate text-sm font-medium">{person.name ?? person.email}</span>
                {person.email ? (
                  <span className="truncate text-[11px] text-muted-foreground">{person.email}</span>
                ) : null}
              </button>
            ))}
            <button
              type="button"
              disabled={pickedId == null}
              onClick={() => {
                if (pickedId == null) return
                const person = candidates.find((row) => row.user_id === pickedId)
                onAssign(pickedId, dueDate || null, person?.name || person?.email || '')
                onClose()
              }}
              className="mt-3 flex min-h-[44px] w-full items-center justify-center gap-2 rounded-lg border border-border text-sm disabled:opacity-40"
            >
              <Check className="h-4 w-4" aria-hidden />
              Assign
            </button>
          </>
        )}
      </div>
    </MobileSheet>
  )
}
